(function () {
    'use strict';

    angular.module('tradersyard').factory('InvitationService', InvitationServiceFactory);

    InvitationServiceFactory.$inject = ['$uibModal'];

    /**
     * NOTE: I'm not sure if we want multiple methods or just a rich interface.
     *
     * @param $uibModal
     * @return {{openInviteModalForSubGroup((string|number), (string|number)): *}|*}
     * @constructor
     */
    function InvitationServiceFactory($uibModal) {
        const ENTRY_TYPE_GROUP = 'group';

        return {
            /**
             * Opens an invitation modal window containing multiple tabs of invite methods.
             *
             * - invite from parent
             * - invite friends
             * - invite from other, own groups
             * - invite via email
             *
             * @param {string|number} groupId
             * @param {string|number} [parentId]
             * @return {Promise<unknown>}
             */
            openInviteModalForSubGroup(groupId, parentId) {
                const modal = $uibModal.open({
                    component: 'tyGroupInvitationModal',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entryType: () => ENTRY_TYPE_GROUP,
                        entryId: () => groupId,
                        parentEntry: () => (parentId ? `${ENTRY_TYPE_GROUP}.${parentId}` : null),
                    },
                });

                return modal.result;
            },
        };
    }
})();
